import customHeaders, { getSpace } from '../../../../common/headers';
import { useDataTable } from '../../../../common/hooks';
import { useState, useRef, useEffect } from 'react';
import { TableBox, RangeBox, Checkbox } from '@lk-gtcom/ecomlab-components';
import useGeneralStore from '../../../../store/general';
import { periodWeek } from '../../../../common/constant';
import { msToLocalDate } from '../../../../common/constant';
import './TaskListTable.scss';


const TaskListTable = ({ project_id }) => {
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);
    const headers = { ...customHeaders, ...getSpace(selectedSpace) };

    const [isShowAdditionalFields, setIsShowAdditionalFields] = useState(false);

    const [date, setDate] = useState(periodWeek());

    // Таблица
    const paginatorRef = useRef();
    const [setTable, tableProps, setTableFuncs] = useDataTable(
        paginatorRef.current?.setTotal,
        paginatorRef
    );
    const { setLoading } = setTableFuncs;

    const fetchTableData = (params, abortController = new AbortController()) => {
        let sort;
        let filters;

        if (params) {
            [sort, filters] = params;
        }

        const [date_from, date_to] = date;
        setLoading(true);

        let url = ` https://portals.ecomru.ru/api/crm/deals/task_list_data/${project_id}`

        const body = JSON.stringify({
            order_field: sort?.[0],
            order_direction: sort?.[1],
            date_from: msToLocalDate(date_from),
            date_to: msToLocalDate(date_to),
            filters,
            limit: paginatorRef.current?.limit,
            page: paginatorRef.current?.page,
            responsible_list: [],
            author_list: [],
            co_executors_list: [],
            show_additional_fields: isShowAdditionalFields,
        });

        fetch(url, {
            body,
            method: 'POST',
            headers,
            signal: abortController.signal,
        })
            .then(async (res) => {
                if (res.ok) {
                    return res.json();
                } else {
                    const err = await res.json();
                    throw new Error(JSON.stringify(err));
                }
            })
            .then((json) => {
                setTable(json);
            })
            .catch((err) => {
                console.error(err);
            })
            .finally(() => {
                if (abortController.signal.aborted) return;
                setLoading(false);
            });
    };

    useEffect(() => {
        const abortController = new AbortController();
        fetchTableData([], abortController);
        return () => abortController.abort();
    }, [date, isShowAdditionalFields]);

    return (
        <div className="task-list-table">
            <RangeBox
                date={date}
                setDate={(e) => setDate(e)}
            />

            <TableBox
                ref={paginatorRef}
                paginator={true}
                {...tableProps}
                fetchCallback={fetchTableData}
                child={
                    <Checkbox
                        value={isShowAdditionalFields}
                        onChange={(e) => setIsShowAdditionalFields(!isShowAdditionalFields)}
                    >
                        Учитывать дополнительные поля
                    </Checkbox>}
            />
        </div>
    );
};

export { TaskListTable };
